export default __webpack_public_path__ + "static/illu-75f6a872e5152bb55aaff7c8195f9e6c.svg";